/* eslint-disable */
export const NOTIFICATION_BASE_URL =
  process.env.REACT_APP_NOTIFICATION_BASE_URL;
export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;
export const CONTRACT_BASE_URL = process.env.REACT_APP_CONTRACT_BASE_URL;
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_BASE_URL;
export const CONTRACT_ACTION_BASES_URL =
  process.env.REACT_APP_CONTRACT_ACTION_BASES_URL;
export const REACT_APP_CONTRACT_BASE_URL = process.env.REACT_APP_CONTRACT_BASE_URL;

export const GET_BANKS_INFO = (id) => `/api/users/${id}/banks`;
export const GET_TRANSACTION = "transactions";
export const GET_BALANCE = (id) => `/balances/${id}`;
export const GET_CHECK_FEEDBACK = (userId, contractId) =>
  `${FEEDBACK_URL}/eligible/${userId}/${contractId}`;
export const FEEDBACK_URL = "/api/feedbacks";
export const PROFILE_URL = "api/profiles";
export const LOGIN_URL = "login";
export const REGISTRATION_URL = "/register";
export const PROFILES = "/profiles";
export const CONTRACT_URL = "/contracts";

export const HYPER_PAY_CALL_BACK_URL =
  process.env.REACT_APP_HYPER_PAY_SHOPPER_URL;
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  RESET: "/reset-pincode",
  SIGNUP: "/signup",
  CONTRACT: "/contract/",
  CONTRACT_DETAILS: "/contract/:id",
  ONBOARDING: "/onboarding",
  PRIVATE_CONTRACT_DETAILS: "/private-contract-details",
  CONTRACT_NOT_FOUND: "/not-found",
  PROFILE: "/profile",
  CONTRACTS_LIST: "/contracts",
  USERS: "/users",
  PAYMENT: "/payment",
  DASHBOARD: "/dashboard",
  PAYMENTS: "/payments",
  USER: "/user/:id"
};
export const PROFILE_PATH_PARAMS = {
  ME: "info",
  ADDRESS: "address",
  PAYMENT_METHOD: "payment-methods",
  PIN_CODE: "pin-code",
  MOBILE_NUMBER: "phone-number",
  FEEDBACK: "feedbacks",
};
export const LOCALIZE_DATE = "ar-EG";
export const DSN_SENTRY =
  "https://adaed12f54a24a3395131765447819d4@o1375625.ingest.sentry.io/6684611";
export const development = "development";
export const production = "production";
